var LOCATIONS_METHOD = /* @__PURE__ */ ((LOCATIONS_METHOD2) => {
  LOCATIONS_METHOD2["OS_LOCATION"] = "OS_LOCATION";
  LOCATIONS_METHOD2["CUSTOM_LOCATION"] = "CUSTOM_LOCATION";
  return LOCATIONS_METHOD2;
})(LOCATIONS_METHOD || {});
export {
  LOCATIONS_METHOD
};
//# sourceMappingURL=types.js.map
